import { BACKEND_CONSTANTS } from './constants'
import { get } from './helpers'

const getReport = async (startDate, endDate) =>
  get(`daily_reports?start_date=${startDate}&end_date=${endDate}`, BACKEND_CONSTANTS.REPORTS.GET_REPORT)

export { getReport }
